var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAboutArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 873,
    height: 75,
    viewBox: "0 0 873 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 43,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#6DFBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 43,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#6DFBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 43,
    width: 740,
    height: 6,
    rx: 3,
    fill: "#6DFBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M846.624 74.3301H814.554L836.474 46.6401L808.164 18.3301H829.824C832.034 18.3301 833.824 20.1201 833.824 22.3301C833.824 24.5401 832.034 26.3301 829.824 26.3301H827.484L847.174 46.0201L831.094 66.3301H843.024L864.834 41.6801C866.294 40.0301 868.824 39.8701 870.484 41.3301C872.134 42.7901 872.294 45.3201 870.834 46.9801L846.644 74.3301H846.624Z",
    fill: "#80F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M859.225 39.2302C858.155 39.2302 857.085 38.8002 856.295 37.9602L829.305 8.95024C827.805 7.33024 827.885 4.80024 829.505 3.30024C831.125 1.79024 833.655 1.89024 835.155 3.50024L862.155 32.5002C863.655 34.1202 863.575 36.6502 861.955 38.1502C861.185 38.8702 860.205 39.2202 859.235 39.2202L859.225 39.2302Z",
    fill: "#80F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.225 18C868.425 18 869.385 18.97 869.385 20.16C869.385 21.35 868.415 22.32 867.225 22.32C866.035 22.32 865.055 21.35 865.055 20.16C865.055 18.97 866.025 18 867.225 18Z",
    fill: "#80F5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M860.274 10C862.044 10 863.484 11.44 863.484 13.21C863.484 14.98 862.044 16.42 860.274 16.42C858.504 16.42 857.064 14.98 857.064 13.21C857.064 11.44 858.504 10 860.274 10Z",
    fill: "#80F5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M853.064 0C855.274 0 857.064 1.79 857.064 4C857.064 6.21 855.274 8 853.064 8C850.854 8 849.064 6.21 849.064 4C849.064 1.79 850.854 0 853.064 0Z",
    fill: "#80F5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M847.59 74.3301H818.04L839.23 47.5601L812 20.3301H831.24C832.9 20.3301 834.24 21.6701 834.24 23.3301C834.24 24.9901 832.9 26.3301 831.24 26.3301H826.48L847.25 47.1001L830.44 68.3301H844.89L866.99 43.3401C868.09 42.1001 869.99 41.9801 871.22 43.0801C872.46 44.1801 872.58 46.0701 871.48 47.3101L847.58 74.3201L847.59 74.3301Z",
    fill: "#6DFBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M860.651 39.23C859.851 39.23 859.041 38.91 858.451 38.27L831.451 9.27002C830.321 8.06002 830.391 6.16002 831.601 5.03002C832.811 3.90002 834.711 3.97002 835.841 5.18002L862.841 34.18C863.971 35.39 863.901 37.29 862.691 38.42C862.111 38.96 861.381 39.22 860.651 39.22V39.23Z",
    fill: "#6DFBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M868.65 19C869.85 19 870.81 19.97 870.81 21.16C870.81 22.35 869.84 23.32 868.65 23.32C867.46 23.32 866.48 22.35 866.48 21.16C866.48 19.97 867.45 19 868.65 19V19Z",
    fill: "#6DFBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.69 11C863.46 11 864.9 12.44 864.9 14.21C864.9 15.98 863.46 17.42 861.69 17.42C859.92 17.42 858.48 15.98 858.48 14.21C858.48 12.44 859.92 11 861.69 11Z",
    fill: "#6DFBFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.48 1C856.69 1 858.48 2.79 858.48 5C858.48 7.21 856.69 9 854.48 9C852.27 9 850.48 7.21 850.48 5C850.48 2.79 852.27 1 854.48 1Z",
    fill: "#6DFBFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAboutArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/about-arrow.4765664324cfce17fcb15bc124d491e0.svg";